const workflowList = [
  {
    name: 'Demand',
    iconName: 'demand',
    type: 'svg',
    isOldLink: true,
    link: '/ui/demand',
  },
  {
    name: 'Placement',
    iconName: 'placement',
    type: 'svg',
    isOldLink: true,
    link: '/ui/placement',
  },
  {
    name: 'Scheduled',
    iconName: 'schedule',
    type: 'svg',
    isOldLink: true,
    link: '/ui/scheduled',
  },
  {
    name: 'Transit',
    iconName: 'transit',
    type: 'svg',
    isOldLink: true,
    link: '/ui/transit',
  },
  {
    name: 'History',
    iconName: 'history',
    type: 'svg',
    isOldLink: true,
    link: '/ui/history',
  },
];

const paymentList = [
  {
    name: 'Pay',
    iconName: 'pay',
    type: 'svg',
    isOldLink: true,
    link: '/ui/pay',
  },
  {
    name: 'Audit',
    iconName: 'audit',
    type: 'svg',
    isOldLink: true,
    link: '/ui/audit',
  },
  {
    name: 'Audit History',
    iconName: 'audithistory',
    type: 'svg',
    isOldLink: true,
    link: '/ui/audithistory',
  },
  {
    name: 'Parties',
    iconName: 'parties',
    type: 'svg',
    isOldLink: true,
    link: '/ui/parties',
  },
  {
    name: 'Collection',
    iconName: 'collection',
    type: 'svg',
    link: '/node/collection',
  },
];

const tripsRoutesList = [
  {
    name: 'Trips',
    iconName: '',
    type: 'svg',
    isOldLink: true,
    link: '/node/trips',
  },
  {
    name: 'Routes',
    iconName: '',
    type: 'svg',
    isOldLink: true,
    link: '/node/routes',
  },
];

const operatorMenu = [
  // {
  //   name: 'Workflow',
  //   iconName: 'Workflow',
  //   isExpandable: true,
  //   list: workflowList,
  //   type: 'svg',
  // },
  // {
  //   name: 'Payments',
  //   iconName: 'Payment',
  //   isExpandable: true,
  //   list: paymentList,
  //   type: 'svg',
  // },
  // {
  //   name: 'New Analytics',
  //   iconName: 'newanalytics',
  //   type: 'svg',
  //   isOldLink: true,
  //   link: '/ui/newanalytics',
  // },
  // {
  //   name: 'MIS',
  //   iconName: 'mis',
  //   isOldLink: true,
  //   type: 'svg',
  //   link: '/ui/mis',
  // },
  // {
  //   name: 'SLA',
  //   iconName: 'sla',
  //   isOldLink: true,
  //   type: 'svg',
  //   link: '/ui/sla',
  // },
  {
    name: 'Fastag',
    iconName: 'fastag',
    type: 'svg',
    link: '/portal/fastag',
    tag: 'new',
  },
  {
    name: 'GPS Dashboard',
    iconName: 'dashboard',
    type: 'svg',
    isOldLink: true,
    link: '/node/dashboard',
  },
  {
    name: 'Diesel Dashboard',
    iconName: 'fuelcon',
    type: 'svg',
    isOldLink: true,
    link: '/node/fuel-dashboard',
  },
  {
    name: 'Reports',
    iconName: 'report',
    type: 'svg',
    isOldLink: true,
    link: '/node/reports',
  },
  {
    name: 'Devices',
    iconName: 'devices',
    type: 'svg',
    isOldLink: true,
    link: '/node/devices',
  },
  // {
  //   name: 'Vehicles',
  //   iconName: 'vehicle',
  //   type: 'svg',
  //   link: '/node/vehicles',
  // },
  {
    name: 'Drivers',
    iconName: 'driver',
    type: 'svg',
    isOldLink: true,
    link: '/node/driver',
  },
  // {
  //   name: 'Consigner',
  //   iconName: 'consigner',
  //   type: 'svg',
  //   link: '/node/consigner',
  // },
  {
    name: 'Saved Places',
    iconName: 'places',
    type: 'svg',
    isOldLink: true,
    link: '/node/places',
  },
  // {
  //   name: 'Lanes',
  //   iconName: 'lanes',
  //   type: 'svg',
  //   isOldLink: true,
  //   link: '/ui/lanes',
  // },
  {
    name: 'UMS',
    iconName: 'ums',
    type: 'svg',
    isOldLink: true,
    link: '/node/ums',
  },
  // {
  //   name: 'Consignments',
  //   iconName: 'consignment',
  //   type: 'svg',
  //   isOldLink: true,
  //   link: '/node/consignment',
  // },
  {
    name: 'Settings',
    iconName: 'settings',
    type: 'svg',
    isOldLink: true,
    link: '/node/settings',
  },
  {
    name: 'Tags',
    iconName: 'tags',
    type: 'svg',
    isOldLink: true,
    link: '/node/tags',
  },
  {
    name: 'Dcm',
    iconName: 'dcm',
    type: 'svg',
    isOldLink: true,
    link: '/node/dcm',
  },
  {
    name: 'Trips & Routes',
    iconName: 'truck',
    isExpandable: true,
    list: tripsRoutesList,
    type: 'svg',
  },
  {
    name: 'E-Lock Dashboard',
    iconName: 'dcm',
    type: 'svg',
    isOldLink: true,
    link: '/node/e-lock-dashboard',
  },
  {
    name: 'Help & Support',
    iconName: 'help',
    type: 'svg',
    isOldLink: true,
    link: '/node/help-support',
  },
];

const consignerMenu = [
  {
    name: 'Vehicles',
    iconName: 'consigner-vehicles',
    type: 'svg',
    link: '/portal/consigner/vehicles',
  },
  {
    name: 'Trips',
    iconName: 'consigner-trips',
    isOldLink: true,
    type: 'svg',
    link: '/ui/consignerview',
  },
  {
    name: 'Reports',
    iconName: 'consigner-reports',
    isOldLink: true,
    type: 'svg',
    link: '/ui/consignerreport',
  },
];

export { operatorMenu, consignerMenu };
